import dayjs, { Dayjs } from 'dayjs'
import arraySupport from 'dayjs/plugin/arraySupport'
dayjs.extend(arraySupport)

export type Ymd = number

export function ymdFromParts(year: number, month: number, day: number): Ymd {
  return year * 10000 + month * 100 + day
}

export function ymdFromDate(date: Date): Ymd {
  return (
    date.getFullYear() * 10000 + (date.getMonth() + 1) * 100 + date.getDate()
  )
}

export function ymdFromISO(isoDate: string): Ymd {
  return ymdFromDate(new Date(isoDate + 'T12:00:00Z'))
}

export function ymdFromDayjs(dayjs: Dayjs): Ymd {
  return ymdFromParts(dayjs.year(), dayjs.month() + 1, dayjs.date())
}

export function ymdParts(ymd: Ymd): {
  year: number
  month: number
  day: number
} {
  let day = ymd % 100
  let month = Math.floor((ymd % 10000) / 100)
  let year = Math.floor(ymd / 10000)
  return { year, month, day }
}

export function ymdISO(ymd: Ymd): string {
  let { year, month, day } = ymdParts(ymd)
  return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(
    2,
    '0'
  )}`
}

export function ymdDayjs(ymd: Ymd): Dayjs {
  let { year, month, day } = ymdParts(ymd)
  return dayjs([year, month - 1, day, 12])
}

export function nextYmd(ymd: Ymd): Ymd {
  let day = ymd % 100
  if (day < 27) {
    return ymd + 1
  } else {
    let d = ymdDayjs(ymd).add(1, 'day')
    return ymdFromParts(d.year(), d.month() + 1, d.date())
  }
}

export function monthYmds(date: Date): Ymd[] {
  let monthStart = dayjs(date).startOf('month')
  let monthEnd = dayjs(date).endOf('month')
  let arr: Ymd[] = []
  for (let d = monthStart; d <= monthEnd; d = d.add(1, 'day')) {
    arr.push(ymdFromDayjs(d))
  }
  return arr
}

export function dayjsRange(start: Dayjs, end: Dayjs): Dayjs[] {
  let arr: Dayjs[] = []
  for (let d = start; d <= end; d = d.add(1, 'day')) {
    arr.push(d)
  }
  return arr
}
